skrilla.directive('excludedUsers',function() {
    return {
        templateUrl: 'directives/excludedUsers/excludedUsers.html',
        scope: {},
        controller: function ($scope, searchService, queryService, paginationService, addressService, userExclusionsService) {
            $scope.pageKey = "excludedUsers";
            $scope.reset = function() {
                $scope.query = {
                    limit: 20
                };
            };
            $scope.reset();

            $scope.search = function(){
                paginationService.resetPage($scope.pageKey);
                paginationService.pageQuery(getUsers, $scope.pageKey);
            }

            var getUsers = function(){
                return searchService.get("users/excludedPersons" + queryService.getQueryString($scope.query, $scope.pageKey)).then(function(response){
                    $scope.users = response.data.result;
                    paginationService.setPage($scope.pageKey, paginationService.buildPage(response));
                });
            }

            $scope.effectiveUntilColour = function (date) {
                return userExclusionsService.getEffectiveUntilColour(date)
            }

            $scope.formatAddress = function (user){
                return addressService.formatAddress(user)
            }

            $scope.search();
        }
    };
});